<template>
  <div class="container">
    <div v-if="isShowXunranReport">
      <div class="report-pc">
        <Pc ref="pcComponent" :reportData="reportData" />
      </div>
      <div class="report-h5">
        <H5 ref="h5Component" :reportData="reportData" />
      </div>
    </div>
    <div v-else>
      <iframe class="iframe-box" :src="rongMengReportUrl" frameborder="0"></iframe>
    </div>
  </div>
</template>

<script>
import Pc from "./components/pc/index";
import H5 from "./components/h5/index";

import throttle from "@/utils/throttle";

import { getTestReportData } from "@/http/api";

export default {
  name: "home",
  components: { Pc, H5 },
  data() {
    return {
      reportData: null,
      rongMengReportUrl: "",
      isShowXunranReport: false, //勋然测试报告
    };
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.throttlerResizeChart);
  },
  destroy() {
    window.removeEventListener("resize", this.throttlerResizeChart);
  },
  mounted() {
    window.addEventListener("resize", this.throttlerResizeChart, false);
    var uuid = this.$route.params.uuid;
    this.getTestReportData(uuid);
  },
  methods: {
    throttlerResizeChart() {
      throttle(this.resizeChart());
    },
    resizeChart() {
      this.$refs.pcComponent.echart_sports_line_canvas.resize();
      this.$refs.h5Component.echart_sports_line_canvas.resize();
    },
    getTestReportData(uuid) {
      getTestReportData(uuid).then((res) => {
        if (res.data.hasOwnProperty("report_url")) {
          this.rongMengReportUrl = res.data.report_url;
        } else {
          this.isShowXunranReport = true;
          this.reportData = res.data;
          this.$nextTick(() => {
            this.$refs.pcComponent.getReportData();
            this.$refs.h5Component.getReportData();
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  width: 1920px;
  min-height: 100vh;
}
.iframe-box {
  width: 1920px;
  height: 100vh;
}
</style>
